/**
 * Internal numeric log level. Higher = more verbose; a Logger method fires
 * when the resolved level is `>=` its own. Not exported from the package's
 * public entry — consumers use `PackageLogLevel` instead.
 */
export enum LogLevel {
	SILENT = 0,
	ERROR = 1,
	WARN = 2,
	INFO = 3,
	DEBUG = 4,
}

export const DEFAULT_LOG_LEVEL: LogLevel = LogLevel.ERROR;

/** Public string form of `LogLevel` for `initializeControls({ packageLogLevel })`. */
export type PackageLogLevel = 'silent' | 'error' | 'warn' | 'info' | 'debug';

const PACKAGE_LOG_LEVEL_BY_STRING: Record<PackageLogLevel, LogLevel> = {
	silent: LogLevel.SILENT,
	error: LogLevel.ERROR,
	warn: LogLevel.WARN,
	info: LogLevel.INFO,
	debug: LogLevel.DEBUG,
};

/** Returns the matching `LogLevel`, or `null` if the value is missing or unrecognized. */
export const packageLogLevelStringToEnum = (value: string | undefined): LogLevel | null => {
	if (value === undefined) {
		return null;
	}
	return PACKAGE_LOG_LEVEL_BY_STRING[value as PackageLogLevel] ?? null;
};
